// extracted by mini-css-extract-plugin
module.exports = {"presenterItemHolder":"PresenterItem_presenterItemHolder__13H9E","topBorder":"PresenterItem_topBorder__iCYaF"};